// extracted by mini-css-extract-plugin
export default {"disclaimer":"aiDisclaimer_disclaimer__htHAt"};